import { Format } from "../../../utils/types/generals"
import { CatalogList } from "../response"

export const formatCatalog = async ({ response }: { response: CatalogList }): Format<CatalogList> => {
    return await {
        item: response.map(catalog => ({
            label: catalog.name,
            value: catalog.id,
            id: catalog.id.toString(),
        })),
        data: response
    }
}